import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import TrashcanIcon from '../../../Icons/Trashcan';
import ConfirmationPopup from '../../../Popup/ConfirmationPopup';
import { deviationTypeToTranslationKey, getDeviationType, getDeviationResourceType, } from '../../../DeviationViews/_helpers';
import { BiEventType } from '../../../biLogger';
export var DeleteButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var _b = useState(false), isShowingConfirmation = _b[0], setShowingConfirmation = _b[1];
    var type = getDeviationType(deviation);
    var typeName = t(deviationTypeToTranslationKey(type));
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionBarButton, { tooltip: t('actionbar.delete'), onClick: function () { return setShowingConfirmation(true); }, isEditAction: true, biData: {
                evid: BiEventType.DEVIATION_DELETE_CLICK,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
            } },
            React.createElement(ActionBarIcon, { icon: TrashcanIcon })),
        React.createElement(ConfirmationPopup, { isOpen: isShowingConfirmation, title: t('actionbar.delete.confirm', { type: typeName }), text: t('actionbar.delete.cantGoBack'), confirmBtnLabel: t('actionbar.delete'), confirmBtnType: "danger", onConfirm: function () {
                setShowingConfirmation(false);
                onClick({ deviation: deviation, shouldRedirect: true });
            }, onCancel: function () { return setShowingConfirmation(false); } })));
};
DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
//# sourceMappingURL=DeleteButton.js.map